import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Asset reservations stats DTO
 */
@CaslSubject(AppSubjectEnum.ASSET_RESERVATION)
export class AssetReservationsStatsDto extends BaseStatsDto {
	pending!: number;
	accepted!: number;
	rejected!: number;
	cancelled!: number;
}
